import React from "react";
import InputField from "components/UI-lib/InputField";

interface NameEnvironmentProps {
  environmentName: string;
  handleNameChange: (val: string) => void;
  nameFieldErrorMessage: string;
}

export const NameEnvironment: React.FC<NameEnvironmentProps> = ({
  environmentName,
  handleNameChange,
  nameFieldErrorMessage,
}) => {
  return (
    <div className="w-full">
      <InputField
        label="Name Instance"
        value={environmentName}
        placeholder="Name your environment"
        errorMessage={nameFieldErrorMessage}
        onChange={handleNameChange}
        className="CodeCard-GitUrlInputField"
      />
    </div>
  );
};
